import { REDUCER_KEY } from './reducer';

export const getProfileStore = (state) => state[REDUCER_KEY];
export const getProfile = (state) => getProfileStore(state).resourcesById.first();
export const getIsLoading = (state) => getProfileStore(state).isLoading;
export const getLoadPending = (state) => getProfileStore(state).loadPending;
